import api from './api';

const routingService = {
  /**
   * Get map data for jobs
   */
  getMapData: (params) => {
    return api.get('/routing/map-data', { params });
  },

  /**
   * Optimize route for a given date
   * @param {string} date - Date in YYYY-MM-DD format
   * @param {string} status - Job status filter (e.g., 'scheduled')
   * @param {string} priority - Optimization priority (Revenue, Balanced, Distance)
   * @param {object} startLocation - Optional { latitude, longitude } for GPS start
   */
  optimizeRoute: (date, status, priority, startLocation = null) => {
    const payload = {
      routeDate: date,
      status: status,
      optimizationPriority: priority,
    };

    if (startLocation) {
      payload.startLatitude = startLocation.latitude;
      payload.startLongitude = startLocation.longitude;
    }

    return api.post('/routing/optimize', payload);
  },

  /**
   * Get navigation URLs for an optimized route
   * @param {array} optimizedJobs - Array of job objects in optimized order
   */
  getNavigationUrls: (optimizedJobs) => {
    return api.post('/routing/navigation-urls', optimizedJobs);
  },

  /**
   * Quick optimize for calendar - returns optimized order for a day's jobs
   * Uses device GPS and business settings automatically
   * @param {string} date - Date in YYYY-MM-DD format
   * @param {object} gpsLocation - { latitude, longitude } from device
   */
  optimizeDay: async (date, gpsLocation) => {
    const payload = {
      routeDate: date,
      status: 'Scheduled', // Only optimize scheduled jobs
      startLatitude: gpsLocation?.latitude,
      startLongitude: gpsLocation?.longitude,
    };

    return api.post('/routing/optimize', payload);
  },
};

export default routingService;